module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d4/btn_2_sp_b0240294340bade3e2799e490c2ac19a.png";